export default {
  promotions: {
    accessIf: {
      roles: ['admin', 'customer_solutions', 'retail_manager', 'marketing', 'ops_admin']
    }
  },
  giftCards: {
    accessIf: {
      roles: ['admin', 'customer_solutions', 'ops_admin']
    }
  },
  stockManagement: {},
  // TECH-1020: store callbacks. Same roles as has_scm_role() in Supabase, which enforces them
  // (RLS); the role is the one of the current env (live_role / test_role)
  scmCallbacks: {
    accessIf: {
      roles: ['admin', 'ops_admin']
    }
  },
  createStockInLocation: {
    accessIfNot: {
      roles: ['sales']
    }
  },
  inventory: {},
  convertToFrame: {},
  consumables: {
    accessIfNot: {
      roles: []
    }
  },
  anonymiseUser: {
    accessIf: {
      roles: ['customer_solutions', 'admin', 'ops_admin']
    }
  },
  // TECH-826: legacy Prestashop order lookup (UI only, the edge function checks no role)
  prestaOrders: {
    accessIf: {
      roles: ['customer_solutions', 'admin', 'ops_admin', 'store_manager', 'retail_manager']
    }
  },
  taskExecutionMenu: {
    accessIf: {
      roles: ['customer_solutions', 'admin', 'ops_admin']
    }
  },
  customerTags: {
    accessIf: {
      roles: ['admin']
    }
  },
  appointmentSummary: {
    accessIf: {}
  },
  // TECH-912: new pickup flow for these roles, plus every employee in the listed stores
  // (warehouse codes, e.g. 'ZRH1'), see usePickupFlowToggle
  pickupFlowToggle: {
    accessIf: {
      roles: ['admin', 'ops_admin']
    },
    stores: ['GRZ1', 'INN1', 'SZG1', 'VIE1', 'VIE2', 'VIE3']
  }
}
